import { Box } from "@saleor/macaw-ui-next";
import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import React from "react";

interface TrendBadgeProps {
  delta: number | null | undefined;
  invert?: boolean;
  suffix?: string;
}

export const TrendBadge: React.FC<TrendBadgeProps> = ({ delta, invert, suffix = "vs prev." }) => {
  if (delta == null || !isFinite(delta)) {
    return null;
  }

  const isFlat = Math.abs(delta) < 0.001;
  const isUp = delta > 0;
  const isPositive = invert ? !isUp : isUp;

  const color = isFlat
    ? "#6B7280"
    : isPositive
      ? "#059669"
      : "#DC2626";
  const bg = isFlat
    ? "rgba(107, 114, 128, 0.12)"
    : isPositive
      ? "rgba(5, 150, 105, 0.12)"
      : "rgba(220, 38, 38, 0.12)";

  const Icon = isFlat ? Minus : isUp ? ArrowUpRight : ArrowDownRight;
  const pct = `${isUp ? "+" : ""}${(delta * 100).toFixed(1)}%`;

  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      gap={1}
      paddingX={2}
      paddingY={1}
      borderRadius={2}
      style={{
        background: bg,
        color,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1,
      }}
    >
      <Icon size={12} />
      <span>{pct}</span>
      <span style={{ opacity: 0.7, fontWeight: 500 }}>{suffix}</span>
    </Box>
  );
};
